import { render, staticRenderFns } from "./jianyan-edit.vue?vue&type=template&id=b6385b36&scoped=true&"
import script from "./jianyan-edit.vue?vue&type=script&lang=ts&"
export * from "./jianyan-edit.vue?vue&type=script&lang=ts&"
import style0 from "./jianyan-edit.vue?vue&type=style&index=0&id=b6385b36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6385b36",
  null
  
)

export default component.exports